import React, { useState } from "react";
import "../../assets/css/CasinoSportsbook.css";
// import img from "../../assets/image/Casinoimage/casino.avif";
import img1 from "../../assets/image/Casinoimage/newi.png";
import img2 from "../../assets/image/Casinoimage/191-removebg-preview.png";
import img3 from "../../assets/image/Casinoimage/monitor_18995919.gif";
import img6 from "../../assets/image/Casinoimage/api_17905501.gif";
import img5 from "../../assets/image/Casinoimage/video-news_15748323.gif";
import img4 from "../../assets/image/Casinoimage/pngtree-slot-casino-machine-landing-header-png-image_13030890-removebg-preview.png";
import Footer from "../Footer/Footer";
import img121 from "../../assets/image/Casinoimage/js121.png";
import { FaReact, FaNodeJs, FaDatabase } from "react-icons/fa";
import { Helmet,HelmetProvider } from "react-helmet-async";
import data from "../../Meta/Meta_ApiUrl"
import {
  FaEnvelope,
  FaSkype,
  FaPhone,
  FaUser,
  FaGlobe,
  FaDollarSign,
  FaChartLine,
  FaPen,
  FaPaperPlane,
  FaBuilding,
  FaTimes,
} from "react-icons/fa";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import { IoLogoWhatsapp, IoMdBuild } from "react-icons/io";
import emailjs from "@emailjs/browser";
import { useRef, useEffect } from "react";


const CasinoSportsbook = () => {

  const [meta,setMeta] =useState({});

  useEffect(()=>{
    const casino = data[0]?.services_page_casino;

    if(casino){
      setMeta(casino);
    }
  },[])
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to top-left corner
  }, []);

  const [isOpenEnquiry, setIsOpenEnquiry] = useState(false);

  const [formDataEnquiry, setFormDataEnquiry] = useState({
    name: "",
    email: "",
    phone: "",
    whatsapp: "",
    companyName: "",
    companyService: "",
    serviceType: "",
    country: "",
    message: "",
  });

  const form = useRef();

  const handleClose = () => {
    setIsOpenEnquiry(false);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormDataEnquiry((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_z73r4mc",
        "template_evcmg1l",
        form.current,
        "EscxBRJBS9wDUay2E"
      )
      .then(
        (result) => {
          alert("Enquiry sent successfully!");
          setIsOpenEnquiry(false);
          setFormDataEnquiry({
            name: "",
            email: "",
            phone: "",
            whatsapp: "",
            companyName: "",
            companyService: "",
            serviceType: "",
            country: "",
            message: "",
          });
        },
        (error) => {
          console.error("Failed to send email:", error.text);
          alert("Failed to send enquiry. Please try again.");
        }
      );
  };

  const leftServices = [
    {
      icon: "🏆",
      title: "First Class API Services",
      description:
        "You might be able to choose from various types of API integrations depending on your platform requirements. This could include REST APIs, WebSocket connections, and GraphQL endpoints for real-time gaming experiences and seamless data flow.",
    },
    {
      icon: "🛡️",
      title: "24/7 Security Monitoring",
      description:
        "They likely offer round-the-clock security services, ensuring you can maintain secure connections at any time, whether it's during peak gaming hours or off-peak maintenance windows.",
    },
  ];

  const rightServices = [
    {
      icon: "⚡",
      title: "Performance at Maximum",
      description:
        "Rainbow Gaming API is known for its commitment to providing high-performance services, focusing on low latency connections. While specific performance metrics can vary depending on individual implementation requirements.",
    },
    {
      icon: "🚀",
      title: "Seamless Integration & Deployment",
      description:
        "When offering integration packages, they typically aim to cater to the specific preferences of developers, providing flexibility for custom implementations, SDK libraries, and comprehensive documentation to enhance the overall experience.",
    },
  ];

  const securityFeatures = [
    {
      title: "Data Encryption",
      description:
        "End-to-end encryption for all sensitive gaming data transfers and financial transactions",
      icon: "🔐",
    },
    {
      title: "Compliance Standards",
      description:
        "Full adherence to gaming industry regulations including PCI DSS and responsible gaming protocols",
      icon: "📋",
    },
    {
      title: "Security Audits",
      description:
        "Regular security assessments and vulnerability testing to ensure platform integrity",
      icon: "🔍",
    },
    {
      title: "Fraud Prevention",
      description:
        "Advanced AI-powered fraud detection and prevention mechanisms for secure gaming",
      icon: "🛡️",
    },
  ];

  const [hoveredCard, setHoveredCard] = useState(null);
  // eslint-disable-next-line
  const integrationFeatures = [
    {
      title: "Live Betting APIs",
      description:
        "Connect to real-time betting systems with advanced odds management",
    },
    {
      title: "Payment Gateways",
      description:
        "Secure payment processing with multiple gateway integrations",
    },
    {
      title: "Game Management",
      description: "Comprehensive game control and management systems",
    },
    {
      title: "Real-Time Data Feeds",
      description: "Live data synchronization for optimal user experience",
    },
  ];

  const securityFeatures1 = [
    {
      title: "Data Encryption",
      description: "End-to-end encryption for all sensitive data transfers",
    },
    {
      title: "Compliance Standards",
      description: "Full adherence to gaming industry regulations",
    },
    {
      title: "Security Audits",
      description: "Regular security assessments and vulnerability testing",
    },
    {
      title: "Fraud Prevention",
      description: "Advanced fraud detection and prevention mechanisms",
    },
  ];

  const apiProviders = [
    {
      name: "QTech",
      features: [
        "Multi-provider platform",
        "Global reach",
        "Instant integration",
      ],
      speciality: "Comprehensive Gaming Solutions",
    },
    {
      name: "BlueOcean",
      features: ["Advanced analytics", "Real-time reporting", "Flexible APIs"],
      speciality: "Sports Betting Excellence",
    },
    {
      name: "Softgamings",
      features: ["Casino games", "Turnkey solutions", "White label"],
      speciality: "Casino Platform Leader",
    },
  ];

  const benefits = [
    {
      title: "Cost-Effective",
      description:
        "Reduce development costs by 70% compared to building from scratch",
    },
    {
      title: "Quick Launch",
      description: "Get to market 5x faster with pre-built integrations",
    },
    {
      title: "Scalable Architecture",
      description: "Easily add new providers and features as you grow",
    },
    {
      title: "24/7 Support",
      description: "Round-the-clock technical support and maintenance",
    },
  ];

  const apiProviders1 = [
    {
      name: "GameTech Solutions",
      speciality: "Sports Betting APIs",
      features: ["Multi-Sport", "Real-time", "24/7 Support"],
      logo: img3,
    },
    {
      name: "Casino Pro API",
      speciality: "Casino Game Integration",
      features: ["Slot Game", "Table Game", "Live Casino"],
      logo: img6,
    },
    {
      name: "DataStream Live",
      speciality: "Real-time Data Feeds",
      features: ["Statistics", "Player Data", "Historical"],
      logo: img5,
    },
  ];

  const [hoveredCard1, setHoveredCard1] = useState(null);

  const technologies1 = [
    {
      name: "React",
      icon: <FaReact />,
      color: "primary",
      description: "A JavaScript library for building fast user interfaces.",
      extra: "Ideal for single-page applications and dynamic web apps.",
    },
    {
      name: "Node.js",
      icon: <FaNodeJs />,
      color: "success",
      description: "Server-side runtime environment using JavaScript.",
      extra: "Handles concurrent connections with non-blocking I/O.",
    },
    {
      name: "Database",
      icon: <FaDatabase />,
      color: "warning",
      description: "Manages and stores structured or unstructured data.",
      extra: "Supports MySQL, MongoDB, PostgreSQL, and more.",
    },
  ];

  const inputStyle = {
    width: "100%",
    padding: "8px 10px",
    border: "2px solid #e9ecef",
    borderRadius: "10px",
    fontSize: "0.95rem",
    background: "white",
    outline: "none",
    transition: "all 0.3s ease",
  };

  return (
    <HelmetProvider>

    <div className="bg-light">
      <Helmet>
               <title>{meta?.title || "Services-CasinoSportsbook  - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED"}</title>
               <meta
                 name="description"
                 content={
                   meta?.meta?.meta1?.content ||
                   "Our curriculum."
                 }
               />
             </Helmet>
      {/* Enquiry Form */}
      {isOpenEnquiry && (
        <div
          onClick={handleBackdropClick}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.6)",
            backdropFilter: "blur(8px)",
            zIndex: 1050,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "100%",
              maxWidth: "650px",
              maxHeight: "100vh",
              background: "#fff",
              borderRadius: "20px",
              overflow: "hidden",
              boxShadow: "0 15px 50px rgba(0,0,0,0.25)",
            }}
          >
            {/* Fixed Header */}
            <div
              style={{
                position: "sticky",
                top: 0,
                background: "#00b7eb",
                color: "#ffffff",
                padding: "15px 20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                zIndex: 2,
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "1.5rem",
                  fontWeight: "700",
                  textAlign: "center",
                }}
              >
                Enquiry Form
              </h3>
              <button
                onClick={handleClose}
                style={{
                  background: "transparent",
                  border: "none",
                  color: "#ffffff",
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              >
                <FaTimes />
              </button>
            </div>

            {/* Scrollable Form */}
            <div
              style={{
                padding: "20px",
                overflowY: "auto",
                maxHeight: "calc(100vh - 70px)", // Adjust based on header height
              }}
            >
              <form ref={form} onSubmit={handleSubmitForm}>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                    gap: "20px",
                    marginBottom: "20px",
                  }}
                >
                  {/* Full Name */}
                  <div>
                    <FaUser
                      style={{
                        color: "#00b7eb",
                        marginRight: "8px",
                        fontSize: "14px",
                      }}
                    />
                    <label className="fw-bold">Full Name *</label>
                    <input
                      type="text"
                      name="name"
                      value={formDataEnquiry.name}
                      onChange={handleInputChange}
                      required
                      placeholder="Enter full name"
                      style={inputStyle}
                    />
                  </div>

                  {/* Email */}
                  <div>
                    <FaEnvelope
                      style={{
                        color: "#00b7eb",
                        marginRight: "8px",
                        fontSize: "14px",
                      }}
                    />
                    <label className="fw-bold">Email Address *</label>
                    <input
                      type="email"
                      name="email"
                      value={formDataEnquiry.email}
                      onChange={handleInputChange}
                      required
                      placeholder="Enter email"
                      style={inputStyle}
                    />
                  </div>

                  {/* Phone */}
                  <div>
                    <FaPhone
                      style={{
                        color: "#00b7eb",
                        marginRight: "8px",
                        fontSize: "14px",
                      }}
                    />
                    <label className="fw-bold">Phone Number</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formDataEnquiry.phone}
                      onChange={handleInputChange}
                      placeholder="Enter phone"
                      style={inputStyle}
                    />
                  </div>

                  {/* WhatsApp */}
                  <div>
                    <IoLogoWhatsapp
                      style={{
                        color: "#00b7eb",
                        marginRight: "8px",
                        fontSize: "14px",
                      }}
                    />
                    <label className="fw-bold">WhatsApp</label>
                    <input
                      type="tel"
                      name="whatsapp"
                      value={formDataEnquiry.whatsapp}
                      onChange={handleInputChange}
                      placeholder="Enter WhatsApp"
                      style={inputStyle}
                    />
                  </div>

                  {/* Company Name */}
                  <div>
                    <FaBuilding
                      style={{
                        color: "#00b7eb",
                        marginRight: "8px",
                        fontSize: "14px",
                      }}
                    />
                    <label className="fw-bold">Company Name</label>
                    <input
                      type="text"
                      name="companyName"
                      value={formDataEnquiry.companyName}
                      onChange={handleInputChange}
                      placeholder="Enter company name"
                      style={inputStyle}
                    />
                  </div>

                  {/* Company Service */}
                  <div>
                    <IoMdBuild
                      style={{
                        color: "#00b7eb",
                        marginRight: "8px",
                        fontSize: "14px",
                      }}
                    />
                    <label className="fw-bold">Company Service</label>
                    <select
                      name="companyService"
                      value={formDataEnquiry.companyService}
                      onChange={handleInputChange}
                      style={inputStyle}
                    >
                      <option value="" disabled>
                        Select
                      </option>
                      <option value="Solo">Solo</option>
                      <option value="Pvt">Pvt</option>
                      <option value="LLP">LLP</option>
                      <option value="Startup">Startup</option>
                      <option value="Partnership">Partnership</option>
                    </select>
                  </div>

                  {/* Service Type */}
                  <div>
                    <MdOutlineMiscellaneousServices
                      style={{
                        color: "#00b7eb",
                        marginRight: "8px",
                        fontSize: "14px",
                      }}
                    />
                    <label className="fw-bold">Type of Service</label>
                    <select
                      name="serviceType"
                      value={formDataEnquiry.serviceType}
                      onChange={handleInputChange}
                      style={inputStyle}
                    >
                      <option value="" disabled>
                        Select
                      </option>
                      <option value="Software">Software Development</option>
                      <option value="App">App Development</option>
                      <option value="Game">Game Development</option>
                      <option value="Website">Website Development</option>
                      <option value="AR & VR Development">AR & VR Apps</option>
                      <option value="Casino Api">Casino API</option>
                      <option value="Devops Solutions">DevOps</option>
                      <option value="It Support">IT Support</option>
                      <option value="Training Programs">Training</option>
                      <option value="Digital Marketing">
                        Digital Marketing
                      </option>
                    </select>
                  </div>

                  {/* Country */}
                  <div>
                    <FaGlobe
                      style={{
                        color: "#00b7eb",
                        marginRight: "8px",
                        fontSize: "14px",
                      }}
                    />
                    <label className="fw-bold">Country</label>
                    <input
                      type="text"
                      name="country"
                      value={formDataEnquiry.country}
                      onChange={handleInputChange}
                      placeholder="Enter country"
                      style={inputStyle}
                    />
                  </div>
                </div>

                {/* Message */}
                <div>
                  <label className="fw-bold">Your Message *</label>
                  <textarea
                    name="message"
                    value={formDataEnquiry.message}
                    onChange={handleInputChange}
                    required
                    rows={1}
                    placeholder="Tell us about your requirements..."
                    style={{
                      ...inputStyle,
                      resize: "vertical",
                    }}
                  />
                </div>

                {/* Submit Button */}
                <div
                  className="mt-1 margin-top-home"
                  style={{ textAlign: "center" }}
                >
                  <button
                    type="submit"
                    style={{
                      background: "#00b7eb",
                      color: "white",
                      padding: "10px 20px",
                      borderRadius: "25px",
                      fontWeight: "600",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    <FaPaperPlane style={{ marginRight: "8px" }} />
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      <div className="position-relative casino-bg bg-light text-dark overflow-hidden min-vh-50 d-flex align-items-center">
        <div className="position-absolute top-0 start-0 w-100 h-100 opacity-20"></div>
        <div className="container position-relative">
          <div className="row align-items-center">
            <div className="col-lg-6 casino-content">
              <nav aria-label="breadcrumb" className="mb-4">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a
                      href="/"
                      className="text-white fw-bold text-decoration-none"
                    >
                      Home
                    </a>
                  </li>
                  <li
                    className="text-white fw-bold breadcrumb-item"
                    aria-current="page"
                  >
                    Casino Sportsbook
                  </li>
                </ol>
              </nav>
              <h3 className="display-5 fw-bold mb-3">Casino & Sportsbook</h3>
            </div>
          </div>
        </div>
      </div>

      {/* Section 1*/}
      <section className=" text-dark position-relative overflow-hidden">
        <div className="container py-2">
          <div className="row align-items-center min-vh-60 mb-3">
            <div className="col-lg-7 col-md-7 col-sm-7 mt-3">
              <h3 className="display-5 fw-bold mb-3">
                Casino & <span className="text-danger">API Integration</span>
              </h3>
              <p className=" font-para  mb-4">
                Connect seamlessly with industry-leading API providers for
                real-time gaming experiences.Seamlessly integrate with top-tier
                API platforms to power real-time gameplay, event
                synchronization, secure transactions, and global scalability for
                your gaming applications.
              </p>
              <div className="container">
                <div className="row gy-3 mb-5">
                  <div className="col-12 col-md-12">
                    <div className="d-flex align-items-center">
                      <span className="rounded-pill text-dark me-2 px-2">
                        ✓
                      </span>
                      <span className="text-dark fw-medium">
                        Multiple API Providers
                      </span>
                    </div>
                  </div>
                  <div className="col-12 col-md-12">
                    <div className="d-flex align-items-center">
                      <span className="rounded-pill text-dark me-2 px-2">
                        ✓
                      </span>
                      <span className="text-dark fw-medium">
                        Real-Time Integration
                      </span>
                    </div>
                  </div>
                  <div className="col-12 col-md-12">
                    <div className="d-flex align-items-center">
                      <span className="rounded-pill text-dark me-2 px-2">
                        ✓
                      </span>
                      <span className="text-dark fw-medium">
                        Secure &amp; Compliant
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div md="auto" className="text-center text-md-start mt-1 mt-md-0">
                <button
                  className="btn btn-red text-white fw-semibold px-4 py-2"
                  onClick={() => setIsOpenEnquiry(true)} // 🔴 This line enables the popup
                >
                  Get Started
                </button>
              </div>
            </div>
            <div className="col-lg-5 col-md-5 col-sm-12 d-none d-lg-block d-md-block">
              <div className="text-center position-relative">
                <img
                  src={img2}
                  alt="API Integration"
                  className="img-fluid rounded-4 "
                  style={{ maxHeight: "450px", objectFit: "cover" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2*/}
      <section className="py-1 bg-light">
        <div className="container">
          <div className="row mb-2">
            <div className="col-12 text-center">
              <button
                className=" btn border  border-danger fw-semibold  bg-transparent  px-3 py-2 rounded-pill  fs-md-5"
                style={{
                  color: "#00b7eb",
                }}
              >
                ROBUST BACKEND TECHNOLOGIES
              </button>
              <h3 className="display-5 fw-bold text-dark mt-2 mb-2">
                Built on Industry-
                <span className="font-red">Leading Technologies</span>
              </h3>
              <p
                className="font-para fs-5 mb-0 mx-auto"
                style={{ maxWidth: "600px" }}
              >
                High-performance, reliable backend technologies ensuring optimal
                integration performance and scalability
              </p>
            </div>
          </div>

          <div className="container my-5">
            <div className="row g-4 mb-5">
              {technologies1.map((tech, index) => (
                <div key={index} className="col-lg-4 col-md-4">
                  <div
                    className="card h-100 border-0 overflow-hidden position-relative shadow-sm"
                    style={{
                      borderRadius: "20px",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      transform:
                        hoveredCard === `tech-${index}`
                          ? "translateY(-12px)"
                          : "translateY(0)",
                      boxShadow:
                        hoveredCard === `tech-${index}`
                          ? "0 12px 40px rgba(0,0,0,0.15)"
                          : "0 4px 20px rgba(0,0,0,0.05)",
                    }}
                    onMouseEnter={() => setHoveredCard(`tech-${index}`)}
                    onMouseLeave={() => setHoveredCard(null)}
                  >
                    <div className="card-body p-2 d-flex flex-column align-items-center text-center">
                      <div
                        className={` d-flex align-items-center justify-content-center rounded-circle `}
                        style={{ width: "100px", height: "100px" }}
                      >
                        <span className="fs-1 ">{tech.icon}</span>
                      </div>
                      <h4 className={`fw-bold text-danger `}>{tech.name}</h4>
                      <p
                        className="font-para fw-medium mb-4"
                        style={{ fontSize: "15px", lineHeight: "1.6" }}
                      >
                        {tech.description}
                      </p>
                      {tech.extra && (
                        <div
                          className="text-dark fs-6"
                          style={{ maxWidth: "90%" }}
                        >
                          {tech.extra}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="row ">
            <div className="row">
              <div className="col-12 mb-5">
                <div className=" rounded-4 p-5">
                  <div className="text-center mb-5">
                    <h3 className="fw-bold font-red mb-3">
                      Why Choose Our Technology Stack?
                    </h3>
                    <p className="font-para mb-0">
                      Our carefully selected technologies deliver
                      enterprise-grade solutions
                    </p>
                  </div>

                  <div className="row g-4">
                    <div className="col-lg-3 col-md-6 text-center">
                      <div className="bg-white rounded-3 p-4 shadow-sm">
                        <div className="text-danger fs-1 mb-3">⚡</div>
                        <h5 className="fw-bold text-dark mb-2">
                          High Performance
                        </h5>
                        <p className="text-dark small mb-0">
                          Optimized for speed and efficiency
                        </p>
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-6 text-center">
                      <div className="bg-white rounded-3 p-4 shadow-sm">
                        <div className="text-primary fs-1 mb-3">🔒</div>
                        <h5 className="fw-bold text-dark mb-2">
                          Enterprise Security
                        </h5>
                        <p className="text-dark small mb-0">
                          Bank-level security protocols
                        </p>
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-6 text-center">
                      <div className="bg-white rounded-3 p-4 shadow-sm">
                        <div className="text-success fs-1 mb-3">📈</div>
                        <h5 className="fw-bold text-dark mb-2">
                          Infinite Scalability
                        </h5>
                        <p className="text-dark small mb-0">
                          Grows with your business needs
                        </p>
                      </div>
                    </div>

                    <div className="col-lg-3 col-md-6 text-center">
                      <div className="bg-white rounded-3 p-4 shadow-sm">
                        <div className="text-secondary fs-1 mb-3">🛠️</div>
                        <h5 className="fw-bold text-dark mb-2">
                          Easy Maintenance
                        </h5>
                        <p className="text-dark small mb-0">
                          Simplified updates and monitoring
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3*/}
      <div className="min-vh-70" style={{ background: "#ffffff" }}>
        {/* Main Services Section */}

        {/* Security & Compliance Section */}
        <div className="py-5">
          <div className="container">
            <div className="row mb-2">
              <div className="col-12 text-center">
                <button
                  className=" btn border  border-danger fw-semibold  bg-transparent  px-3 py-2 rounded-pill fs-6 fs-md-5"
                  style={{
                    color: "#00b7eb",
                  }}
                >
                  Security & Compliance
                </button>
                <h3
                  className="display-6 fw-bold mb-3"
                  style={{ color: "#000000" }}
                >
                  Enterprise-<span className="font-red">Grade Security</span>
                </h3>
                <p
                  className=" font-para fs-5 mb-2 mx-auto"
                  style={{ maxWidth: "600px", color: "#6c757d" }}
                >
                  Protecting sensitive gaming data with industry-leading
                  security protocols and compliance standards for casino
                  operations
                </p>
              </div>
            </div>
          </div>
          <div className="container ">
            <div className="row align-items-center min-vh-40">
              {/* Left Services */}
              <div className="col-lg-4">
                {leftServices.map((service, index) => (
                  <div key={index} className="mb-2">
                    <div className="d-flex align-items-start">
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                        style={{
                          width: "60px",
                          height: "60px",
                          background: "#00b7eb",
                        }}
                      >
                        <span style={{ fontSize: "28px", color: "#ffffff" }}>
                          {service.icon}
                        </span>
                      </div>
                      <div className="flex-grow-1">
                        <h4
                          className="fw-bold mb-2"
                          style={{ color: "#000000" }}
                        >
                          {service.title}
                        </h4>
                        <p className=" font-para mb-0">{service.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="col-lg-4 text-center">
                <div className="position-relative">
                  <div className="mx-auto rounded-4 overflow-hidden" style={{}}>
                    <div className="d-flex flex-column align-items-center justify-content-center h-100 gap-3">
                      <img
                        src={img4}
                        alt="Gaming Theme"
                        style={{
                          width: "350px",
                          height: "350px",
                          borderRadius: "8px",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Services */}
              <div className="col-lg-4">
                {rightServices.map((service, index) => (
                  <div key={index} className="mb-4">
                    <div className="d-flex align-items-start">
                      <div
                        className="rounded-circle d-flex align-items-center mx-2 justify-content-center   flex-shrink-0 order-lg-2"
                        style={{
                          width: "50px",
                          height: "50px",
                          background: "#00b7eb",
                        }}
                      >
                        <span style={{ fontSize: "28px", color: "#ffffff" }}>
                          {service.icon}
                        </span>
                      </div>
                      <div className="flex-grow-1 text-lg-end order-lg-1 ">
                        <h4
                          className="fw-bold ml-3 mb-2"
                          style={{ color: "#000000" }}
                        >
                          {service.title}
                        </h4>
                        <p className="font-para">{service.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Additional Features Section */}
        {/* <div className="py-5" style={{background: '#000000'}}>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h3 className="text-white fw-bold mb-4">Why Choose Our Casino API Integration?</h3>
            </div>
          </div>
          <div className="row g-4">
            <div className="col-md-4 text-center">
              <div className="mb-3">
                <span style={{fontSize: '48px', color: '#00b7eb'}}>⚡</span>
              </div>
              <h5 className="text-white fw-bold">Lightning Fast</h5>
              <p style={{color: '#6c757d'}}>Ultra-low latency for real-time gaming experiences</p>
            </div>
            <div className="col-md-4 text-center">
              <div className="mb-3">
                <span style={{fontSize: '48px', color: '#00b7eb'}}>🎯</span>
              </div>
              <h5 className="text-white fw-bold">99.9% Uptime</h5>
              <p style={{color: '#6c757d'}}>Reliable infrastructure with guaranteed availability</p>
            </div>
            <div className="col-md-4 text-center">
              <div className="mb-3">
                <span style={{fontSize: '48px', color: '#00b7eb'}}>🔧</span>
              </div>
              <h5 className="text-white fw-bold">Easy Integration</h5>
              <p style={{color: '#6c757d'}}>Comprehensive SDKs and documentation for quick setup</p>
            </div>
          </div>
        </div>
      </div> */}
      </div>

      {/* Section 4*/}

      <div className="bg-light">
        <section className="py-3">
          <div className="container">
            {/* Header Section */}
            <div className="row mb-5">
              <div className="col-12 text-center">
                <div className="">
                  <button
                    className=" btn border border-danger fw-semibold  bg-transparent  px-3 py-2 rounded-pill fs-6 fs-md-5"
                    style={{
                      color: "#00b7eb",
                    }}
                  >
                    Trusted Partners
                  </button>
                </div>
                <h3 className="display-6  fw-bold text-dark mt-2 mb-3">
                  Premium API <span className="font-red">Providers</span>
                </h3>
                <p className="font-para   mb-0 mx-auto">
                  Connect with industry-leading providers for comprehensive
                  gaming solutions and unlock powerful integrations for your
                  platform
                </p>
              </div>
            </div>

            {/* Provider Cards */}
            <div className="row g-4 mb-5">
              {apiProviders1.map((provider, index) => (
                <div key={index} className="col-lg-4 col-md-4">
                  <div
                    className="card border-0 h-100"
                    style={{
                      boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                      borderRadius: "16px",
                    }}
                  >
                    <div className="card-body p-2 text-center">
                      {/* Logo Section */}
                      <div className="mb-2">
                        <div
                          className="d-inline-flex align-items-center justify-content-center rounded-circle border"
                          style={{
                            width: "60px",
                            height: "60px",
                            backgroundColor: "#f8f9fa",
                            borderColor: "#e9ecef",
                          }}
                        >
                          <img
                            src={provider.logo}
                            alt={provider.name}
                            className="rounded-circle"
                            style={{
                              width: "80px",
                              height: "80px",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                      </div>

                      {/* Provider Info */}
                      <h4 className="fw-bold text-dark mb-2">
                        {provider.name}
                      </h4>
                      <p className="text-danger fw-semibold mb-4 fs-6">
                        {provider.speciality}
                      </p>

                      {/* Features */}
                      <div className="mb-4">
                        {provider.features.map((feature, idx) => (
                          <span
                            key={idx}
                            className="me-2 fw-semibold mb-2 px-3 py-2 feature-badge"
                          >
                            {feature}
                          </span>
                        ))}
                      </div>

                      {/* CTA Button */}
                      <button className="btn btn-red text-white fw-semibold px-4 py-2">
                        Learn More
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Benefits Section */}
            <div className="row">
              <div className="col-12">
                <div
                  className="text-dark rounded-4 p-5"
                  style={{
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #e9ecef",
                  }}
                >
                  <div className="text-center mb-5">
                    <h3 className="fw-bold mb-3" style={{ color: "#00b7eb" }}>
                      Why Choose Our API Partners?
                    </h3>
                    <p className="font-para mb-0">
                      Industry-leading solutions designed for scale and
                      reliability
                    </p>
                  </div>

                  <div className="row g-4">
                    <div className="col-md-4 text-center">
                      <div className="mb-3">
                        <div
                          className="d-inline-flex align-items-center justify-content-center rounded-circle bg-danger text-white mb-3"
                          style={{ width: "60px", height: "60px" }}
                        >
                          <i className="fas fa-globe-americas fs-4"></i>
                        </div>
                      </div>
                      <h5 className="fw-bold text-dark mb-3">
                        Global Coverage
                      </h5>
                      <p className="font-para mb-0">
                        Worldwide gaming content and markets with comprehensive
                        regional support and localized solutions
                      </p>
                    </div>

                    <div className="col-md-4 text-center">
                      <div className="mb-3">
                        <div
                          className="d-inline-flex align-items-center justify-content-center rounded-circle bg-danger text-white mb-3"
                          style={{ width: "60px", height: "60px" }}
                        >
                          <i className="fas fa-bolt fs-4"></i>
                        </div>
                      </div>
                      <h5 className="fw-bold text-dark mb-3">Real-Time Data</h5>
                      <p className="font-para mb-0">
                        Live odds and instant updates with millisecond precision
                        for competitive advantage
                      </p>
                    </div>

                    <div className="col-md-4 text-center">
                      <div className="mb-3">
                        <div
                          className="d-inline-flex align-items-center justify-content-center rounded-circle bg-danger text-white mb-3"
                          style={{ width: "60px", height: "60px" }}
                        >
                          <i className="fas fa-code fs-4"></i>
                        </div>
                      </div>
                      <h5 className="fw-bold text-dark mb-3">
                        Easy Integration
                      </h5>
                      <p className="font-para mb-0">
                        Simple, well-documented APIs with comprehensive SDKs and
                        developer-friendly tools
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
    </HelmetProvider>
  );
};
export default CasinoSportsbook;
